import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Button, Form, Row, Col } from "react-bootstrap";
import { allSharedComponents } from "../../../../shared";
import {
  translationConstants,
  subscriptionUserTypeEmun,
} from "../../../../constants";
import { SubscriptionActions } from "../../../../redux/actions";

const SubscriptionSettings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { SpinnerContainer, SubscriptionFields } = allSharedComponents;
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [isEditMode, setIsEditMode] = useState(false);

  const [vat, setVat] = useState([]);
  const [center, setCenter] = useState([]);
  const [practitioner, setPractitioner] = useState([]);
  const [freelancer, setFreelancer] = useState([]);

  const allSubscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );

  const onSubmit = (data) => {
    const formattedData = Object.keys(data).reduce((acc, key) => {
      const fieldId = key;
      const price = data[key];
      if (price !== undefined && price !== null) {
        acc.push({ id: fieldId, price: price });
      }
      return acc;
    }, []);
    dispatch(SubscriptionActions.updateSubscriptionPrices(formattedData));
    setIsEditMode(!isEditMode);
  };

  useEffect(() => {
    if (allSubscriptionPrices) {
      setVat(allSubscriptionPrices.filter((x) => x.userType === null));
      setPractitioner(
        allSubscriptionPrices.filter(
          (x) => x.userType === subscriptionUserTypeEmun.PRACTITIONER
        )
      );
      setCenter(
        allSubscriptionPrices.filter(
          (x) => x.userType === subscriptionUserTypeEmun.CENTER
        )
      );
      setFreelancer(
        allSubscriptionPrices.filter(
          (x) => x.userType === subscriptionUserTypeEmun.FREELANCE
        )
      );
    }
  }, [dispatch, allSubscriptionPrices]);

  useEffect(() => {
    setValue(`${vat[0]?.id}`, vat[0]?.price);
    setValue(`${practitioner[0]?.id}`, practitioner[0]?.price);
    setValue(`${center[0]?.id}`, center[0]?.price);
    setValue(`${center[1]?.id}`, center[1]?.price);
    setValue(`${center[2]?.id}`, center[2]?.price);
    setValue(`${center[3]?.id}`, center[3]?.price);
    setValue(`${freelancer[0]?.id}`, freelancer[0]?.price);
    setValue(`${freelancer[1]?.id}`, freelancer[1]?.price);
    setValue(`${freelancer[2]?.id}`, freelancer[2]?.price);
    setValue(`${freelancer[3]?.id}`, freelancer[3]?.price);
  }, [vat, center, practitioner, freelancer]);

  useEffect(() => {
    dispatch(SubscriptionActions.GetAllSubscriptionPrices({ isLoading: true }));
    //eslint-disable-next
  }, [dispatch]);

  return (
    <div className="UserDiv">
      <Row className="view-user-modal">
        <Col
          md={10}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="UserTabHeading">
            {t(translationConstants.SUBSCRIPTION_SETTINGS)}
          </p>
          <p className="editButton mt-3 me-3">
            {!isEditMode && (
              <>
                {t(translationConstants.edit)}{" "}
                <svg
                  onClick={() => {
                    setIsEditMode(!isEditMode);
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.5833 24.167V15.7087H24.1667V24.167H4.83332V4.83366H13.2917V2.41699H4.83332C3.49863 2.41699 2.41666 3.49897 2.41666 4.83366V24.167C2.41666 25.5017 3.49863 26.5837 4.83332 26.5837H24.1667C25.5013 26.5837 26.5833 25.5017 26.5833 24.167ZM23.1735 3.29113C22.6197 2.73287 21.8613 2.41699 21.0701 2.41699C20.2799 2.41699 19.5223 2.73216 18.9653 3.29258L8.85284 13.4049C7.94921 14.2011 7.35685 15.3858 7.25391 16.66L7.24999 20.5448V21.7531H12.246C13.6166 21.6591 14.813 21.061 15.657 20.0874L25.7121 10.0365C26.27 9.47869 26.5834 8.72206 26.5834 7.93313C26.5834 7.1442 26.27 6.38757 25.7121 5.82971L23.1735 3.29113ZM12.1606 19.3395C12.8062 19.2938 13.407 18.9934 13.8895 18.4415L21.2143 11.1167L17.8862 7.78836L10.5078 15.1644C10.0182 15.5974 9.71536 16.2031 9.66666 16.7573V19.3372L12.1606 19.3395ZM19.5954 6.0798L22.9232 9.40782L24.0033 8.3277C24.1079 8.22305 24.1667 8.08112 24.1667 7.93313C24.1667 7.78514 24.1079 7.6432 24.0033 7.53856L21.4613 4.99661C21.3579 4.89232 21.217 4.83366 21.0701 4.83366C20.9232 4.83366 20.7824 4.89232 20.6789 4.99661L19.5954 6.0798Z"
                    fill="#007F58"
                  />
                </svg>
              </>
            )}
          </p>
        </Col>
      </Row>

      <Form
        noValidate
        className="ViewUserContent px-4 pb-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${vat[0]?.id} - ${t(
                translationConstants.VAT_PERCENTAGE
              )}`}
              endLabel="%"
              disabled={!isEditMode}
              register={{
                ...register(`${vat[0]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 100,
                    message: t(translationConstants.MUST_BE_100_OR_LESS),
                  },
                }),
              }}
            />
            {errors[vat[0]?.id] && (
              <p className="text-danger">{errors[vat[0]?.id]?.message}</p>
            )}
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <div className="d-flex align-items-center">
              <p className="viewUserPara">
                {t(translationConstants.Practitioner_Membership)}
              </p>
              <p className="ps-1 font-20">{`(${t(
                translationConstants.YEARLY
              )})`}</p>
            </div>
          </Col>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${
                practitioner[0]?.id
              } - ${t(translationConstants.Membership_Fees)}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${practitioner[0]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[practitioner[0]?.id] && (
              <p className="text-danger">
                {errors[practitioner[0]?.id]?.message}
              </p>
            )}
            <p className="subscription-horizental-line " />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <div className="d-flex align-items-center">
              <p className="viewUserPara">
                {t(translationConstants.Center_Membership)}
              </p>
              <p className="ps-1 font-20">{`(${t(
                translationConstants.YEARLY
              )})`}</p>
            </div>
          </Col>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${center[0]?.id} - ${t(
                translationConstants.SAILING
              )}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${center[0]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />{" "}
            {errors[center[0]?.id] && (
              <p className="text-danger">{errors[center[0]?.id]?.message}</p>
            )}
            <p className="subscription-horizental-line " />
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${center[1]?.id} - ${t(
                translationConstants.KITE_SURFING
              )}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${center[1]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />{" "}
            {errors[center[1]?.id] && (
              <p className="text-danger">{errors[center[1]?.id]?.message}</p>
            )}
            <p className="subscription-horizental-line " />
          </Col>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${center[3]?.id} - ${t(
                translationConstants.WIND_SURFING
              )}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${center[3]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[center[3]?.id] && (
              <p className="text-danger">{errors[center[3]?.id]?.message}</p>
            )}
            <p className="subscription-horizental-line " />
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${center[2]?.id} - ${t(
                translationConstants.WING_FOILING
              )}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${center[2]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[center[2]?.id] && (
              <p className="text-danger">{errors[center[2]?.id]?.message}</p>
            )}
            <p className="subscription-horizental-line " />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <div className="d-flex align-items-center">
              <p className="viewUserPara">
                {t(translationConstants.Freelance_Instructor)}
              </p>
              <p className="ps-1 font-20">{`(${t(
                translationConstants.SSF_Endorsed_yearly
              )})`}</p>
            </div>
          </Col>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${
                freelancer[0]?.id
              } - ${t(translationConstants.SAILING)}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${freelancer[0]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[freelancer[0]?.id] && (
              <p className="text-danger">
                {errors[freelancer[0]?.id]?.message}
              </p>
            )}
            <p className="subscription-horizental-line " />
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${
                freelancer[1]?.id
              } - ${t(translationConstants.KITE_SURFING)}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${freelancer[1]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[freelancer[1]?.id] && (
              <p className="text-danger">
                {errors[freelancer[1]?.id]?.message}
              </p>
            )}
            <p className="subscription-horizental-line " />
          </Col>
          <Col md={4} className="p-3 text-center">
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${
                freelancer[3]?.id
              } - ${t(translationConstants.WIND_SURFING)}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${freelancer[3]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[freelancer[3]?.id] && (
              <p className="text-danger">
                {errors[freelancer[3]?.id]?.message}
              </p>
            )}
            <p className="subscription-horizental-line " />
            <SubscriptionFields
              startLabel={`${t(translationConstants.ID)}:${
                freelancer[2]?.id
              } - ${t(translationConstants.WING_FOILING)}`}
              currencyLabel={translationConstants.SAR}
              disabled={!isEditMode}
              register={{
                ...register(`${freelancer[2]?.id}`, {
                  required: t(translationConstants.THIS_FIELD_IS_REQUIRED),
                  min: {
                    value: 0,
                    message: t(translationConstants.VALUE_CANNOT_BE_NEGATIVE),
                  },
                  max: {
                    value: 9007199254740991,
                    message: t(translationConstants.INVALID_AMOUNT),
                  },
                }),
              }}
            />
            {errors[freelancer[2]?.id] && (
              <p className="text-danger">
                {errors[freelancer[2]?.id]?.message}
              </p>
            )}
            <p className="subscription-horizental-line " />
          </Col>
        </Row>

        <Row>
          <Col md={8}>
            {isEditMode && (
              <div className="inputRow">
                <div className="col-12  d-flex justify-content-lg-end justify-content-center">
                  <Button
                    className="update-button max-width-btn mt-2"
                    type="submit"
                  >
                    {t(translationConstants.Update)}
                  </Button>
                </div>

                <div className="col-12 d-flex justify-content-lg-start justify-content-center">
                  <button
                    onClick={() => setIsEditMode(!isEditMode)}
                    className="CancelUserView-button mt-2"
                    type="button"
                  >
                    {t(translationConstants.cancel)}
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SubscriptionSettings;
